module.exports = __webpack_public_path__ + "img/tap.e90e2f9b.png";